import { render, staticRenderFns } from "./sinupTip.vue?vue&type=template&id=a910fc98&scoped=true"
import script from "./sinupTip.vue?vue&type=script&lang=js"
export * from "./sinupTip.vue?vue&type=script&lang=js"
import style0 from "./sinupTip.vue?vue&type=style&index=0&id=a910fc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a910fc98",
  null
  
)

export default component.exports